var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRating3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "296px",
    height: "296px",
    viewBox: "0 0 296 296",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "rating-3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rating-3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.996,123.998 C270.996,112.664 269.633,101.65 267.089,91.098 C259.82,75.946 249.739,62.39 237.531,51.102 C215.14,37.726 188.765,30.436 160.759,31.457 C83.492,34.274 23.139,99.196 25.955,176.463 C26.368,187.767 28.125,198.702 31.042,209.136 C37.345,221.146 45.439,232.074 54.976,241.556 C76.868,255.745 102.966,263.996 130.999,263.996 C208.316,263.996 270.996,201.316 270.996,123.998 Z M197.666,98.998 C206.502,98.998 213.666,106.162 213.666,114.998 C213.666,123.834 206.502,130.998 197.666,130.998 C188.83,130.998 181.666,123.834 181.666,114.998 C181.666,106.162 188.83,98.998 197.666,98.998 Z M98.666,130.998 C89.83,130.998 82.666,123.834 82.666,114.998 C82.666,106.162 89.83,98.998 98.666,98.998 C107.502,98.998 114.666,106.162 114.666,114.998 C114.666,123.834 107.502,130.998 98.666,130.998 Z",
    id: "Shape",
    fill: "#FFCE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.089,91.098 C269.633,101.651 270.996,112.664 270.996,123.998 C270.996,201.316 208.316,263.996 130.998,263.996 C102.966,263.996 76.867,255.745 54.975,241.556 C78.855,265.3 111.741,279.996 147.998,279.996 C220.782,279.996 279.996,220.782 279.996,147.998 C279.996,127.636 275.358,108.337 267.089,91.098 Z",
    id: "Shape",
    fill: "#FFB100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.76,31.457 C188.766,30.436 215.141,37.725 237.532,51.102 C213.985,29.328 182.521,16 147.998,16 C75.214,16 16,75.214 16,147.998 C16,170.047 21.442,190.847 31.042,209.136 C28.125,198.702 26.368,187.767 25.955,176.463 C23.139,99.196 83.492,34.274 160.76,31.457 Z",
    id: "Shape",
    fill: "#FFE454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.998,0 C66.392,0 0,66.392 0,147.998 C0,229.604 66.392,295.996 147.998,295.996 C229.604,295.996 295.996,229.604 295.996,147.998 C295.996,66.392 229.605,0 147.998,0 Z M147.998,279.996 C111.741,279.996 78.855,265.3 54.975,241.556 C45.439,232.074 37.344,221.146 31.041,209.136 C21.442,190.847 16,170.047 16,147.998 C16,75.214 75.214,16 147.998,16 C182.521,16 213.985,29.328 237.531,51.102 C249.739,62.39 259.82,75.946 267.089,91.098 C275.359,108.337 279.996,127.636 279.996,147.998 C279.996,220.782 220.782,279.996 147.998,279.996 Z",
    id: "Shape",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#000000",
    cx: 98.666,
    cy: 114.998,
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#000000",
    cx: 197.666,
    cy: 114.998,
    r: 16
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path-Copy",
    fill: "#000000",
    x: 115,
    y: 201,
    width: 66,
    height: 16
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating3);
export default __webpack_public_path__ + "static/media/rating-3.68017f004751aaab6f05a9ce7a015856.svg";
export { ForwardRef as ReactComponent };